import { api } from "@/api";

class API {
  static getItemsLegacyImportation(payload) {
    return api.get("/v1/importacoeslegado", { params: payload });
  }

  static getItemsStatusLegacyImportation() {
    return api.get("/v1/importacoeslegado/status/suggest");
  }

  static getItemsTypeLegacyImportation() {
    return api.get("/v1/importacoeslegado/tipo/suggest");
  }

  static postLegacyImportation(payload) {
    return api.post("/v1/importacoeslegado", payload);
  }

  static putCancelLegacyImportation(id) {
    return api.put(`/v1/importacoeslegado/${id}/cancelar`);
  }

  static getGroupEconomic(payload) {
    return api.get("/v1/gruposeconomicos/suggest", { params: payload });
  }
}

export default API;
